import axios from 'axios';
import { getAuthToken } from './authService';

const API_URL = 'https://club-coca-cola-api.vercel.app/api/v1/back';
const AUTH_TOKEN = 'Bearer FeMsA@2024';

export interface ProcessType {
  id: number;
  name: string;
  description?: string;
}

export interface Process {
  id?: number;
  name: string;
  type: number;
  status: 'active' | 'inactive';
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  day_time: string;
  emails?: string;
}

export const getProcessTypes = async (): Promise<ProcessType[]> => {
  try {
    const url = `${API_URL}/process/types`;
    console.log('Llamando a la API de tipos:', url);
    console.log('Con token:', AUTH_TOKEN);
    
    const response = await axios.get(url, {
      headers: {
        'Authorization': AUTH_TOKEN,
        'Content-Type': 'application/json'
      }
    });
    
    console.log('Respuesta completa de tipos:', response);
    console.log('Status:', response.status);
    console.log('Data:', response.data);
    
    // Validar que la respuesta sea un array
    const data = response.data;
    if (Array.isArray(data)) {
      console.log('Tipos encontrados (array directo):', data);
      return data;
    } else if (data && Array.isArray(data.types)) {
      console.log('Tipos encontrados (data.types):', data.types);
      return data.types;
    } else if (data && Array.isArray(data.data)) {
      console.log('Tipos encontrados (data.data):', data.data);
      return data.data;
    } else {
      console.warn('La respuesta de la API no contiene un array de tipos:', data);
      return [];
    }
  } catch (error: any) {
    console.error('Error completo al obtener los tipos de proceso:', error);
    console.error('Error response:', error.response);
    throw error;
  }
};

export const getProcesses = async (): Promise<Process[]> => {
  try {
    const response = await axios.get(`${API_URL}/processes`, {
      headers: {
        'Authorization': AUTH_TOKEN,
        'Content-Type': 'application/json'
      }
    });
    
    // Validar que la respuesta sea un array
    const data = response.data;
    if (Array.isArray(data)) {
      return data;
    } else if (data && Array.isArray(data.processes)) {
      return data.processes;
    } else if (data && Array.isArray(data.data)) {
      return data.data;
    } else {
      console.warn('La respuesta de la API no contiene un array de procesos:', data);
      return [];
    }
  } catch (error) {
    console.error('Error al obtener los procesos:', error);
    throw error;
  }
};

export const getProcessByName = async (name: string): Promise<Process> => {
  try {
    const response = await axios.get(`${API_URL}/processes/${name}`, {
      headers: {
        'Authorization': AUTH_TOKEN,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el proceso ${name}:`, error);
    throw error;
  }
};

export const createProcess = async (process: Omit<Process, 'id'>): Promise<Process> => {
  try {
    const response = await axios.post(
      `${API_URL}/processes`,
      process,
      {
        headers: {
          'Authorization': AUTH_TOKEN,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error al crear el proceso:', error);
    throw error;
  }
};

export const updateProcess = async (process: Process): Promise<Process> => {
  try {
    const response = await axios.put(
      `${API_URL}/processes`,
      process,
      {
        headers: {
          'Authorization': AUTH_TOKEN,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error al actualizar el proceso:', error);
    throw error;
  }
};

export const deleteProcess = async (id: number): Promise<void> => {
  try {
    await axios.delete(`${API_URL}/processes/${id}`, {
      headers: {
        'Authorization': `Bearer ${AUTH_TOKEN}`,
        'Content-Type': 'application/json'
      }
    });
  } catch (error) {
    console.error('Error al eliminar el proceso:', error);
    throw error;
  }
};
